
const digest = 'be0155353bb42ee277d880fe25d07adfd56f8cf23a5be4cd8d9ea2a4b3424d70';
const classes = {"button":"_button_4b9jz_1"};
const css = `._button_4b9jz_1 {
  border-color: #d81616;
  background-color: #d81616;
  font-family: Rubik, sans-serif;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 13px 16px;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  margin-top: 20px;
  border-radius: 25px;
}
._button_4b9jz_1:hover, ._button_4b9jz_1:active, ._button_4b9jz_1:focus {
  border-color: #b00b0b !important;
  background-color: #b00b0b !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  